import querystring from "querystring";
import { canUseDOM } from "./dom";
import url from "url";
const useQuery = () => {
  const search = canUseDOM() ? window.location.search : null;
  return search ? querystring.parse(search.substr(1)) : {};
};
/**
 * @param {String} queryParams
 * @return {Array.<String>}
 */
export const useQueryParams = (...queryParams) => {
  const query = useQuery();
  const result = [];
  for (let param of queryParams) {
    let val = null;
    for (let _key of Object.keys(query)) {
      if (_key.toLowerCase() === param.toLowerCase()) {
        val = query[_key];
        break;
      }
    }
    result.push(val);
  }
  return result;
};
export const getQuery = (queryObj, key) => {
  for (let _key of Object.keys(queryObj)) {
    if (_key.toLowerCase() === key.toLowerCase()) {
      return queryObj[_key];
    }
  }
  return null;
};
export default useQuery;
